import { render, staticRenderFns } from "./assumptions.vue?vue&type=template&id=f84a736a&scoped=true&"
import script from "./assumptions.vue?vue&type=script&lang=js&"
export * from "./assumptions.vue?vue&type=script&lang=js&"
import style0 from "./assumptions.vue?vue&type=style&index=0&id=f84a736a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../Retirement Planner.Admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f84a736a",
  null
  
)

export default component.exports